<template>
  <div :class="['vip-container',{showtabs:showtabs,showBuy:showBuy,showAd:showAd}]" v-if="(info && info.memberGoods)">
    <!-- 冻结蒙层 -->
    <i class="frozen" v-if="memberStatus==='FROZEN'"></i>
    <div class="top-ad" v-if="showAd" data-sensors-click data-sensors-exposure-event-name="Element_Exposure" @click="jumpOutLink(dBanner.jumpUrl)" :style="`background-image:url(${dBanner.image})`">
      <span class="close" @click.stop="closeAd"></span>
    </div>
    <van-tabs
      v-model="active"
      color="#333333"
      line-width="84"
      line-height="4"
      title-active-color="#333333"
      title-inactive-color="#BBBBBB"
      :sticky="false"
      :offset-top="128"
      v-if="(vipInfo.memberFundList && vipInfo.memberFundList.length>1)"
    >
      <van-tab title="月卡"> </van-tab>
      <van-tab title="半年卡"> </van-tab>
      <van-tab title="年卡"> </van-tab>
    </van-tabs>

    <!-- banner -->
    <div class="banner"  >
      <div class="bg"></div>
      <div class="content">
        <h2>{{info.memberGoods.goodsName}}</h2>
        <p v-if="!memberStatus">{{info.memberGoods.goodsDesc}}</p>
        <p v-else>{{memberInfo.maskMobile}}</p>
        <div class="banner-bottom">
          <span>
            <template v-if="['NORMAL','FROZEN'].includes(memberStatus)"> {{formatDate(memberInfo.expireDate)}} 到期</template>
            <template v-if="memberStatus==='EXPIRED'"> {{formatDate(memberInfo.expireDate)}} 已失效</template>
          </span>
          <nd-button class="btn" @click="toVip()" v-if="memberStatus!=='EXPIRED'">查看详情 ></nd-button>
          <nd-button class="btn" @click="dialog.vipPast=true" v-else>立即续费 ></nd-button>
        </div>
      </div>
    </div>
    <div class="skc-point"></div>
    <!-- 尊享权益 -->
    <section class="qy-container">

      <img src="./images/img_zunxiangtitle.png" class="title">
      <div class="qy-swiper-container">
        <swiper :options="swiperOptions" id="swiper" @slideChange="slideChange">
          <swiper-slide
            v-for="(item,index) in  info.financeBenefitList.concat(info.financeBenefitList)"
            :key="index"
          >
            <div class="content">
              <img :src="item.icon" >
              <h4>{{item.benefitTitle}}</h4>
              <p>{{item.benefitDesc}}</p>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <nd-button class="btn" @click="buyVip">立享特权</nd-button>
    </section>

    <!-- 生活权益 -->
    <section class="life-container">
      <template  v-if="info.mainLifeBenefitList.length">
        <img src="./images/img_shenghuo.png" >
        <section class="content" v-for="(item,index) in info.mainLifeBenefitList" :key="index">
          <div class="title"><h3>权益{{info.mainLifeBenefitList.length>1?alias[index]:''}}：{{item.equityTitle}}</h3> <span>{{item.equityDesc}}</span></div>
          <swipe-container :list="item.lifeBenefitList"  @on-confrim="confrim"></swipe-container>
        </section>
      </template>
    </section>
    <!-- 广告swiper -->
    <div class="ad-banner" v-if="info.memberGoods.saveCardIcon">
      <van-swipe  :duration="500" :loop="true" :autoplay="5000">
        <van-swipe-item @click="jumpMiddle" data-sensors-click>
          <img :src="info.memberGoods.saveCardIcon"  />
        </van-swipe-item>
      </van-swipe>
    </div>
    <p v-if="memberStatus==='FROZEN'" class="refund" style="font-size:28px;text-align:center">退款中，请耐心等待</p>
    <!-- 底部开通按钮 -->
    <section class="footer" v-if="!memberStatus" :class="{hasCoupon}">
      <!-- 优惠券信息 -->
      <coupon-info
        v-if="hasCoupon"
        :couponDiscountValue="couponInfo.couponDiscountValue"
        :useEndTime="couponInfo.useEndTime"
        @updateTime="couponInfo.useEndTime=0"
      />

      <div class="btn" @click="buy" data-sensors-click>
        <div class="price">
          <template v-if="showBubble || hasCoupon">限时</template>优惠价 <span class="red">￥{{info.memberGoods.discountPrice}} </span>
          <span class="line-through">原价 ￥{{info.memberGoods.price}}</span>
        </div>
        <span class="text-right">立即开通</span>
      </div>
      <span class="ui-bubble" v-if="info.memberGoods.expireDate && (info.memberGoods.expireDate - new Date().getTime() >0) && !hasCoupon">
        <van-count-down
          :time="info.memberGoods.expireDate - new Date().getTime()"
          format="DD天HH时mm分"
        />后涨价
      </span>
      <p>开通即同意 <span  @click="routerToVipProtocol(info.memberGoods.supplier)">《会员用户协议》</span></p>
    </section>

    <!-- 弹窗/未开通时—权益介绍弹窗 -->
    <nd-dialog v-model="dialog.welfare" :footer="false" closeBtn class="activity-dialog">
      <div class="activity-template-content">
        <div class="title">{{welfare.title}}</div>
        <div class="content">
          <template v-if="welfare.pop && welfare.pop.length">
            <h4>权益内容：</h4>
            <p v-html="welfare.pop[0].info"></p>
            <template v-if="welfare.pop[1]">
              <h4>权益数量：</h4>
              <p v-html="welfare.pop[1].info"></p>
            </template>
          </template>
        </div>
        <div class="button-group">
          <nd-button class="btn" @click="buy"  data-sensors-click>立即领取</nd-button>
          <div class="xy-tips">
            领取即同意 <span class="active" @click="routerToVipProtocol(info.memberGoods.supplier)">《会员用户协议》</span>
          </div>
        </div>
      </div>
    </nd-dialog>

    <!-- 弹窗/过期—权益介绍弹窗 -->
    <nd-dialog v-model="dialog.vipPast" :footer="false" closeBtn class="activity-dialog">
      <div class="activity-template-content">
        <div class="title">{{passTitle}}已过期</div>
        <div class="content">
          <p v-html="'您的会员身份已过期，现在续充即可畅享会员尊享权益与生活权益！'"></p>
          <div class="more" @click="toVip('Y')">
            <img src="./images/icon_info.png" alt="">
            查看更多权益 >
          </div>
        </div>
        <!-- 优惠券信息 -->
        <coupon-info
          v-if="hasCoupon"
          class="dialog-coupon-info"
          :couponDiscountValue="couponInfo.couponDiscountValue"
          :useEndTime="couponInfo.useEndTime"
          @updateTime="couponInfo.useEndTime=0"
        />
        <div class="button-group" :class="{hasCoupon}">
          <nd-button class="btn" @click="buy" data-sensors-click>
            <template v-if="showBubble || hasCoupon">限时</template>优惠价 <span class="red">￥{{info.memberGoods.discountPrice}} </span><span class="line-through yj">原价 ￥{{info.memberGoods.price}}</span>
            <span class="ui-bubble" v-if="info.memberGoods.expireDate && (info.memberGoods.expireDate - new Date().getTime() >0) && !hasCoupon">
              <van-count-down
                :time="info.memberGoods.expireDate - new Date().getTime()"
                format="DD天HH时mm分"
              />后涨价
            </span>
          </nd-button>

          <div class="xy-tips" >
            开通即同意 <span class="active" @click="routerToVipProtocol(info.memberGoods.supplier)">《会员用户协议》</span>
          </div>
        </div>
      </div>
    </nd-dialog>
    <!-- 冻结 -->
  </div>
</template>
<script>
import { Tab, Tabs, Swipe, SwipeItem } from 'vant'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapActions } from 'vuex'
import { getKey, setKey } from '@/assets/utils'
import qs from 'qs'
import 'swiper/css/swiper.min.css'

export default {
  components: {
    swiper,
    swiperSlide,
    'van-tab': Tab,
    'van-tabs': Tabs,
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    'swipe-container': () => import('./components/swipe-container.vue'),
    'coupon-info': () => import('@/components/coupon-info/index.vue')
  },
  props: {
    deviceInfo: {
      type: Object,
      default: () => ({})
    },
    vipInfo: {
      type: Object,
      default: () => ({
        memberFundList: [],
        memberInfo: null
      })
    }
  },
  data () {
    return {
      dialog: {
        welfare: false,
        vipPast: false
      },
      supplier: '',
      alias: ['一', '二', '三', '四', '五', '六', '七', '八'],
      showAd: false,
      welfare: {},
      dBanner: {},
      activeIndex: 1,
      swiperOptions: {
        // autoplay: {
        //   delay: 500,
        //   disableOnInteraction: true
        // },
        loop: true,
        initialSlide: 1,
        slidesPerView: 2,
        centeredSlides: true,
        watchActiveIndex: true,
        spaceBetween: -160
        // slidesPerView: 3
        // cube: {
        //   slideShadows: true,
        //   shadow: true,
        //   shadowOffset: 100,
        //   shadowScale: 0.6
        // }
      },
      active: 0,
      status: '过期'
    }
  },
  computed: {
    hasCoupon () {
      return this.couponInfo?.useEndTime - new Date().getTime() > 0
    },
    passTitle () {
      if (this.info && this.info.memberGoods && this.info.memberGoods.goodsName) {
        return this.info.memberGoods.goodsName.split('·')[0]
      }
      return ''
    },
    showtabs () {
      return this.vipInfo.memberFundList.length > 1
    },
    showBuy () {
      return !this.memberStatus
    },
    unBuy () {
      return !this.vipInfo.memberInfo
    },
    showBubble () {
      return this.info.memberGoods.expireDate && (this.info.memberGoods.expireDate - new Date().getTime() > 0)
    },
    info () {
      if (!this.vipInfo || !this.vipInfo.memberFundList) {
        return {}
      }
      if (this.vipInfo.memberFundList.length === 3) {
        return this.vipInfo.memberFundList[this.active]
      }
      return this.vipInfo.memberFundList[0]
    },
    memberInfo () {
      return this.vipInfo.memberInfo || {}
    },
    memberStatus () {
      if (!this.vipInfo.memberInfo) {
        return null
      } else {
        return this.vipInfo.memberInfo.memberStatus
      }
    },
    couponInfo () {
      return this.info.couponInfo || {}
    }
  },
  async mounted () {
    const { success, data } = await this.discoverBanner()
    if (success && data && data.jumpUrl && this.isIntervalDay('discoverBanner', 1)) {
      this.dBanner = data
      this.showAd = true
    }
    this.$sensors.track('find_pageview', {
      page_status: this.vipInfo.memberFundList[0].memberGoods.memberGoodsCd,
      additinal_status: this.memberStatus
    })

    console.log()
  },
  methods: {
    ...mapActions('vip', [
      'discoverBanner'
    ]),
    ...mapActions('user', [
      'fundPageRoute'
    ]),
    slideChange (item) {
      const $swiper = document.getElementById('swiper')
      this.activeIndex = $swiper.swiper.realIndex
    },
    jumpOutLink (url) {
      window.location.href = url
    },
    toVip (more = 'N') {
      this.$router.push(`/vip/index?findTarget=${this.info.memberGoods.memberGoodsCd}&more=${more}`)
    },
    confrim (item) {
      // 未购买
      if (!this.memberStatus) {
        this.welfare.title = item.equityTitle
        this.welfare.pop = JSON.parse(item.popInfo.replace(/\n/g, '<br/>') || '[]')
        this.dialog.welfare = true
      } else if (this.memberStatus === 'NORMAL') { // 正常
        const queryParams = qs.stringify({
          benefitType: item.equityType,
          memberNo: this.memberInfo.memberNo,
          memberSupplier: this.info.memberGoods.supplier,
          token: getKey('userInfo', 'token') || '',
          refurl: window.location.origin
        })
        window.location.href = process.env.VUE_APP_PAYURL + '/findMiddle?' + queryParams
      } else { // 过期
        this.dialog.vipPast = true
      }
    },
    buyVip () {
      if (!this.memberStatus) {
        this.buy()
      } else {
        this.showWelfare()
      }
    },
    showWelfare () {
      const item = this.info.financeBenefitList[this.activeIndex]
      if (!this.memberStatus) {
        this.welfare.title = item.benefitTitle
        this.welfare.pop = JSON.parse(item.pop.replace(/\n/g, '<br/>') || '[]')
        this.dialog.welfare = true
      } else if (this.memberStatus === 'EXPIRED') {
        this.dialog.vipPast = true
      } else {
        this.toVip()
      }
    },
    routerToVipProtocol (supplier) {
      if (supplier === 'JI_WEI') {
        this.$router.push('/protocol/vip-jw')
      } else if (supplier === 'WH') {
        this.$router.push('/protocol/vip-wh')
      } else {
        this.$router.push('/protocol/vip')
      }
    },
    closeAd () {
      this.showAd = false
      setKey('discoverBanner', Date.now())
    },
    // 0元省钱卡跳转
    jumpMiddle () {
      const { saveCardBenefitType, supplier, saveCardPop } = this.info.memberGoods
      if (!this.memberStatus) {
        this.welfare.title = '0元省钱卡'
        this.welfare.pop = JSON.parse(saveCardPop.replace(/\n/g, '<br/>') || '[]')
        this.dialog.welfare = true
      } else if (this.memberStatus === 'EXPIRED') {
        this.dialog.vipPast = true
      } else {
        const queryParams = qs.stringify({
          benefitType: saveCardBenefitType,
          memberNo: this.memberInfo.memberNo,
          memberSupplier: supplier,
          token: getKey('userInfo', 'token') || '',
          refurl: window.location.origin
        })
        window.location.href = process.env.VUE_APP_PAYURL + '/findMiddle?' + queryParams
      }
    },
    buy () {
      this.dialog.vipPast = false
      const host = encodeURIComponent(window.location.href)
      const gid = localStorage.getItem('gid')
      const token = getKey('userInfo', 'token') || ''
      const device = getKey('X-DEVICE-IF')
      const queryParams = {
        memberType: this.info.memberGoods.memberGoodsCd,
        memberGoodsGroupCd: this.info.memberGoods.memberGoodsGroupCd,
        discountPrice: this.info.memberGoods.expirePrice || this.info.memberGoods.discountPrice,
        host,
        gid,
        token,
        device,
        refurl: window.location.origin
      }
      if (this.couponInfo.serialNo) {
        queryParams.couponSerialNos = this.couponInfo.serialNo
      }
      window.location.href = process.env.VUE_APP_PAYURL + '/pay?' + qs.stringify(queryParams)
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.vip-container {
  background: #F7F7F7;
  min-height: 100vh;
  padding-bottom: 120px;
  position: relative;
  .ui-bubble {
    background: linear-gradient(90deg, #FF5F34 0%, #FF3333 100%);
    border-radius: 20px 20px 20px 0px;
    color: #fff;
    font-size: 20px;
    padding: 4px 20px;
    position: absolute;
    left: 44%;
    top: -5px;
    display: flex;
    height: 44px;
    align-items: center;
    .van-count-down {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffd8bc;
      line-height: 33px;
    }
  }
  .frozen {
    position: absolute;
    width:100%;
    height:100%;
    z-index: 99;
    background: rgba(255, 255, 255, 0.5);
    top:0
  }
  .top-ad {
    width:100% ;
    height:60px;
    background:#fff url(./images/banner_fengxianbaogao.png) no-repeat center;
    background-size: 710px 100%;
    position: absolute;
    top:0;
    z-index: 100;
    .close {
      width:60px;
      height:100%;
      position: absolute;
      right:25px;
    }
  }
  &.showAd{
    padding-top: 90px;
  }
  &.showAd.showtabs{
    padding-top: 150px;
  }

  &.showtabs{
    padding-top: 98px;
  }
  &.showBuy{
    padding-bottom: 280px;
  }
  &.showBuy.showtabs{
    padding-bottom: 300px;
  }
  .activity-dialog {
    /deep/.default-content {
      background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
    }
    .dialog-coupon-info {
      width: 480px;
      height: 80px;
      left: 70px;
    }
    .title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #763e12;
      line-height: 45px;
      text-align: center;
    }
    .content {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #763e12;
      line-height: 37px;
      padding: 30px 50px;
    }
    h4 {
      margin-top: 20px;
    }
    .more{
      display: flex;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #763E12;
      align-items: center;
      margin-top: 10px;
      img {
        width:32px;
        height:32px;
        margin-right: 10px;
      }
    }
    .button-group {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px 0;
      position: relative;
      .ui-bubble{
        left: 55%;
      }
      .btn {
        width: 480px;
        height: 74px;
        background: linear-gradient(270deg, #d79663 0%, #e4b378 100%);
        .yj {
          font-size: 24px;
          padding-left: 20px;
          text-decoration: line-through;
        }
      }
      &.hasCoupon {
        .btn {
          margin-top: 20px;
        }
      }


    }
    .xy-tips {
      color: #763e12;
      text-align: center;
      margin-top: 30px;
      font-size: 24px;
      .active {
        color: #763e12;
        text-decoration: underline;
      }
    }
  }
  .qy-swiper-container{
    /deep/.swiper-wrapper{
      .swiper-slide {
        // width: 280px !important;
        height: 320px !important;
        text-align: center;
        font-size: 18px;
        transition: 300ms;
        transform: scale(0);
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        .content{
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 280px !important;
          height: 320px !important;
          background: linear-gradient(180deg, #FFFFFF 0%, #FCD5AC 100%);
          border-radius: 20px;
          overflow: hidden;
          padding-top: 70px;
          img{
            width:120px;
            height:120px;
          }
          h4 {
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #763E12;
            width: 90%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            margin-top: 23px;
            text-align: center;
          }
          p{
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763E12;
            width: 90%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            text-align: center;
          }

        }


      }
      .swiper-slide-active,.swiper-slide-duplicate-active{
        transform: scale(1);
        z-index: 9;
      }
      .swiper-slide-prev,.swiper-slide-next{
        z-index: 8;
        transform: scale(0.8);
        opacity: .6;
      }
    }
  }

  .frozen-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    top: 0;
    z-index: 999;
  }

  .footer {
    display: flex;
    flex-direction: column;
    position: fixed;
    width: 750px;
    padding-bottom: 10px;
    background: #FFFFFF;
    bottom: 95px;
    align-items: center;
    padding-top: 16px;
    p {
      font-size: 24px;
      padding-top: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999999;
      text-align: center;
      span {
        color: #8EB2D8;
      }
    }
    .btn {
      width:670px;
      height:88px;
      background: url(./images/btn_vip.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      position: relative;
      &>span {
        width: 180px;
        color: #fff;
      }
      .price {
        flex:1;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;text-align: center;
        .red {
          color: #FF4633;
        }
      }
      .text-right {
        font-size: 30px;
        font-weight: bold;
      }
      .line-through{
        text-decoration: line-through;
        font-size: 24px;
        color: #999;
      }
    }
    // 有限时优惠券
    &.hasCoupon {
      .btn {
        margin-top: 50px;
      }


    }

  }
  .ad-banner{
    width:670px;
    height:220px;
    margin-bottom: 300px;
    margin: 0px auto;
    /deep/.van-swipe-item{
      width:670px;
      height:220px;
      img{
        width:100%;
        height:100%;
      }
    }
  }

  .life-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 90px;

    &>img {
      width: 250px;
    }
    .content {
      padding: 40px;
      .title {
        background: url(./images/icon_quanyi.png) no-repeat left center;
        background-size: 32px 32px;
        display: flex;
        padding-left: 55px;
        align-items: center;
        margin-bottom: 16px;
        h3 {
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333;
        }
        span {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          padding-left: 10px;
        }
      }
    }
  }
  .banner {
    position: relative;
    width:100%;
    height:310px;
    & .bg {
      position: absolute;
      content: "";
      width: 100%;
      height: 490px;
      background: linear-gradient(180deg, #FF4633 0%, #F7F7F7 53%, #F7F7F7 100%);
      left: 50%;top: 50%;
      transform: translate(-50%, -50%);
    }
    .content {
      position: relative;
      width:730px;
      height:310px;
      background: url(./images/img_card_qingxiang.png) no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      position: relative;
      margin-top: 18px;
      padding: 40px 60px;
    }

    h2 {
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #5B2A04;
    }
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5B2A04;
      padding-top: 10px;
    }
    .banner-bottom{
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      span {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5B2A04;
      }
    }
    .btn {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      width: 160px;
      height: 48px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 33px;
    }
  }

  .qy-container{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none;
    .title {
      width: 250px;
    }
    .btn {
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      width: 320px;
      height: 74px;
      background: linear-gradient(270deg, #D79663 0%, #E4B378 100%);
      position: relative;
      margin-top: 20px;
    }
    &:before{
      content: "";
      position: absolute;
      width:670px;
      height:410px;
      background: #fff;
      border-radius: 20px;
      top: 110px;
    }
    .qy-swiper-container{
      width:670px;
      height:320px;
      position: relative;
      margin-top: 40px;
      background: none;
    }
  }
  &.showAd {
    /deep/.van-tabs--line .van-tabs__wrap{
      top:60px
    }
  }
  /deep/.van-tabs--line .van-tabs__wrap {
    position: fixed;
    top:0;
    width: 100%;
    height: 98px;
    z-index: 99;
    .van-tab {
      font-size: 36px;
      height: 98px;
      line-height: 98px;
    }
    .van-tab__text1 {
      height: 98px;
    }
    .van-ellipsis {
      margin-top: 23px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 50px;
    }
  }

}
</style>